<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1>Configuration</h1>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="#">Home</a></li>
            <li class="breadcrumb-item active">Blank Page</li>
          </ol>
        </div>
      </div>
    </div>
    <!-- /.container-fluid -->
  </section>

  <section class="content">
    <!-- Default box -->
    <div class="row">

    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-4" >
                <div class="card ">
                    <div class="card-header">
                      <h3 class="card-title">Liste des organisations</h3>
                      <div class="card-tools">
                        <!-- Buttons, labels, and many other things can be placed here! -->
                      </div>
                      <!-- /.card-tools -->
                    </div>

                    <table mat-table [dataSource]="configurations" class="mat-elevation-z8">

                      <!--- Note that these columns can be defined in any order.
                            The actual rendered columns are set as a property on the row definition" -->
                    
                      <!-- Position Column -->
                      <ng-container matColumnDef="Organisation">
                        <th mat-header-cell *matHeaderCellDef> Organisation </th>
                        <td mat-cell *matCellDef="let configuration"> {{configuration.organisation}} </td>
                      </ng-container>
                    
                      <!-- Name Column -->
                      <ng-container matColumnDef="Key">
                        <th mat-header-cell *matHeaderCellDef> Key </th>
                        <td mat-cell *matCellDef="let configuration"> {{configuration.key}} </td>
                      </ng-container>
                    
                      <!-- Weight Column -->
                      <ng-container matColumnDef="Visibility">
                        <th mat-header-cell *matHeaderCellDef> Visibility </th>
                        <td mat-cell *matCellDef="let configuration"> <span class="badge badge-primary">{{configuration.visibility}} </span></td>
                      </ng-container>
                    
                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr
                          mat-row
                          (click)="onSelect(row)"
                          *matRowDef="let row; columns: displayedColumns;"
                      ></tr>
                    </table>
                    <!-- /.card-body -->
                    <div class="card-footer">
                      The footer of the card
                    </div>
                    <!-- /.card-footer -->
                </div>
            </div>
            <div class="col-lg-4" >
                <div class="card ">
                    <div class="card-header">
                      <h3 class="card-title">Default Card Example</h3>
                      <div class="card-tools">
                        <!-- Buttons, labels, and many other things can be placed here! -->
                        <!-- Here is a label for example -->
                        <span class="badge badge-primary">DEV</span>
                      </div>
                      <!-- /.card-tools -->
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body">
                        <ngx-json-viewer [json]="formattedJsonDev" [depth]="1"></ngx-json-viewer>
                    </div>
                    <!-- /.card-body -->
                    <div class="card-footer">
                      The footer of the card
                    </div>
                    <!-- /.card-footer -->
                </div>
            </div>
            <div class="col-lg-4" >
                <div class="card ">
                    <div class="card-header">
                      <h3 class="card-title">Default Card Example</h3>
                      <div class="card-tools">
                        <!-- Buttons, labels, and many other things can be placed here! -->
                        <!-- Here is a label for example -->
                        <span class="badge badge-primary">UAT</span>
                      </div>
                      <!-- /.card-tools -->
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body">
                        <ngx-json-viewer [json]="formattedJsonUat" [depth]="1"></ngx-json-viewer>
                    </div>
                    <!-- /.card-body -->
                    <div class="card-footer">
                      The footer of the card
                    </div>
                    <!-- /.card-footer -->
                </div>
            </div>
        </div>
        
          <!-- /.card -->
    </div>
    <!-- /.card -->
  </section>